module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageNotFoundTitle":"Seite nicht gefunden","pageNotFoundDescription":"Es tut uns leid, aber die angefragte Seite ist nicht verfügbar."},"en":{"pageNotFoundTitle":"Page not found","pageNotFoundDescription":"We are sorry, but the page you are trying to reach is not available."}}')
  delete Component.options._Ctor
}
